var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouseCommissioning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9 8.10002H14.22C15.2281 8.10002 15.7321 8.10002 16.1172 8.29621C16.4559 8.46878 16.7312 8.74415 16.9038 9.08284C17.1 9.46788 17.1 9.97193 17.1 10.98V17.1M9.9 17.1V3.78002C9.9 2.77193 9.9 2.26788 9.70381 1.88284C9.53124 1.54415 9.25587 1.26878 8.91718 1.09621C8.53214 0.900024 8.02809 0.900024 7.02 0.900024H3.78C2.77191 0.900024 2.26786 0.900024 1.88282 1.09621C1.54413 1.26878 1.26876 1.54415 1.09619 1.88284C0.9 2.26788 0.9 2.77193 0.9 3.78002V17.1M18 17.1H0M4.05 4.50002H6.75M4.05 8.10002H6.75M4.05 11.7H6.75",
    stroke: "#118F84",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseCommissioning);
export default __webpack_public_path__ + "static/media/HOUSE_COMMISSIONING.2e0a1a8924f54420a8a08f2480c5eda3.svg";
export { ForwardRef as ReactComponent };